module.exports = __webpack_public_path__ + "img/BF.ec0fa95f.svg";